import type { TriggerConfig } from '@/types/custom-playbooks';

/** 6sense buying stages, in order, as the 6sense package writes them. */
export const SIXSENSE_STAGES = [
  'Target',
  'Awareness',
  'Consideration',
  'Decision',
  'Purchase',
] as const;

export const SIXSENSE_PRODUCT_MAX = 80;

/** What keeps a 6sense stage trigger from saving, null when it is ready. */
export function sixsenseTriggerIssue(
  config: Partial<TriggerConfig>
): string | null {
  const crm = config.crm;
  if (
    config.source !== 'crm' ||
    config.kind !== 'sixsense_stage' ||
    crm?.crmType !== 'salesforce' ||
    crm.objectType !== 'Account' ||
    crm.conditionType !== 'sixsense_stage'
  )
    return 'A 6sense stage trigger reads Salesforce accounts.';
  const stages = crm.stages ?? [];
  if (
    !stages.length ||
    new Set(stages).size !== stages.length ||
    stages.some(
      (stage) => !(SIXSENSE_STAGES as readonly string[]).includes(stage)
    )
  )
    return 'Pick at least one 6sense stage.';
  if (
    crm.minIntent != null &&
    (typeof crm.minIntent !== 'number' ||
      !Number.isFinite(crm.minIntent) ||
      crm.minIntent < 0 ||
      crm.minIntent > 100)
  )
    return 'The minimum score must be 0 to 100.';
  if (
    crm.product !== undefined &&
    (typeof crm.product !== 'string' ||
      !crm.product.trim() ||
      crm.product.length > SIXSENSE_PRODUCT_MAX)
  )
    return `The product name must be 1 to ${SIXSENSE_PRODUCT_MAX} characters.`;
  if (crm.backfill !== undefined && !['now', 'historic'].includes(crm.backfill))
    return 'Choose which accounts to pick up.';
  return null;
}
